require([],
function () {

    function initHandlers() {
        // Enter key pressed in input field
        $(".search-box input").off("keypress").on("keypress", function (event) {
            if (event.which == 13) {
                runSearch(event);
            }
        });
        // clicking on icon
        $('.search-box i').off('click').on('click', runSearch);
    }

    function runSearch(event) {
        var page = $(event.target).closest(".search-box").data("searchPageUrl");
        var keyword = $(event.target).closest(".search-box").find("input").val();
        window.location.href = page + "?keyword=" + keyword;
    }

    initHandlers();
});

define("SearchBox/main", function(){});

